module.exports = __webpack_public_path__ + "static/media/brain-weights.22b92458.png";